module.exports = __webpack_public_path__ + "static/media/red-close-icon.69777caa.svg";